import React, { useState } from 'react';
import { CheckCircle2, ChevronDown, ChevronUp } from 'lucide-react';
export function ProductShowcase() {
  const [openTomo, setOpenTomo] = useState<number | null>(null);
  const tomos = [{
    id: 'T1',
    icon: '📘',
    title: 'TOMO 1 — Fundamentos del Mantenimiento Industrial',
    subtitle: 'La base que todo alumno técnico necesita antes de tocar una máquina real.',
    table: [{
      tema: 'Qué es el mantenimiento',
      aprende: 'Aplicado a la industria real y al contexto técnico argentino'
    }, {
      tema: 'Tipos de mantenimiento',
      aprende: 'Correctivo, preventivo y predictivo con ejemplos de PyMES locales'
    }, {
      tema: 'Rol del técnico',
      aprende: 'Su lugar en la planta, su responsabilidad y su valor profesional'
    }, {
      tema: 'Tipos de fallas',
      aprende: 'Clasificación, causas raíz y consecuencias reales en producción'
    }, {
      tema: 'Ciclo de vida de un equipo',
      aprende: 'Desde la instalación hasta la baja, explicado para el taller'
    }, {
      tema: 'El técnico y la empresa',
      aprende: 'Cómo impacta el mantenimiento en los costos y la producción'
    }],
    ficha: '✅ Fichas de clase incluidas: Clase 1 a Clase 5 listas — desde ¿Qué es el mantenimiento? hasta análisis de fallas reales con casos de industrias argentinas.'
  }, {
    id: 'T2',
    icon: '📗',
    title: 'TOMO 2 — Diagnóstico de Fallas',
    subtitle: 'Enseñar a escuchar una máquina: el puente entre ver el síntoma y encontrar la causa real.',
    table: [{
      tema: 'Cómo detectar una falla',
      aprende: 'Síntomas visuales, sonoros, térmicos y eléctricos en contexto real'
    }, {
      tema: 'Análisis de síntomas',
      aprende: 'Metodología paso a paso para no confundir síntoma con causa'
    }, {
      tema: 'Fallas comunes en máquinas',
      aprende: 'Motores, bombas, correas, rodamientos y sistemas eléctricos'
    }, {
      tema: 'Métodos de diagnóstico',
      aprende: 'Observación, medición, análisis y verificación aplicados al taller'
    }, {
      tema: 'Procedimientos paso a paso',
      aprende: 'Protocolos claros para intervenir una máquina con seguridad'
    }, {
      tema: 'Ejercicios de análisis',
      aprende: 'Casos simulados para que el alumno diagnostique solo'
    }],
    ficha: '✅ Actividades incluidas: Casos de falla para analizar, fichas de síntoma-causa-solución y ejercicios de diagnóstico progresivo por nivel de dificultad.'
  }, {
    id: 'T3',
    icon: '📙',
    title: 'TOMO 3 — Mantenimiento Preventivo',
    subtitle: 'Planificar antes de que falle: el hábito que separa al técnico del improvisador.',
    table: [{
      tema: 'Planificación del mantenimiento',
      aprende: 'Cómo organizar las tareas antes de que el equipo falle'
    }, {
      tema: 'Rutinas de mantenimiento',
      aprende: 'Diarias, semanales y mensuales con ejemplos reales'
    }, {
      tema: 'Inspecciones técnicas',
      aprende: 'Qué revisar, cómo registrarlo y qué significa cada lectura'
    }, {
      tema: 'Checklists aplicados',
      aprende: 'Formatos reales usados en plantas industriales argentinas'
    }, {
      tema: 'Lubricación técnica',
      aprende: 'Tipos, frecuencias, procedimientos y errores comunes'
    }, {
      tema: 'Tensión de correas y alineación',
      aprende: 'Procedimientos prácticos listos para el taller escolar'
    }],
    ficha: '✅ Actividades incluidas: Completar checklists reales, diseñar rutinas de mantenimiento y simular inspecciones en los equipos del taller escolar.'
  }, {
    id: 'T4',
    icon: '📕',
    title: 'TOMO 4 — Mantenimiento Correctivo',
    subtitle: 'Reparar con método: del diagnóstico a la máquina funcionando.',
    table: [{
      tema: 'Protocolo de intervención',
      aprende: 'Cómo actuar ante una falla sin improvisar y sin riesgo'
    }, {
      tema: 'Uso de herramientas',
      aprende: 'Cuál usar, cómo usarla y cuándo no tocar nada'
    }, {
      tema: 'Desarme y montaje seguro',
      aprende: 'Procedimientos reales de taller con orden y registro'
    }, {
      tema: 'Detección de pieza fatigada',
      aprende: 'Cómo identificar cuándo una pieza ya no puede seguir'
    }, {
      tema: 'Casos reales de reparación',
      aprende: 'Situaciones resueltas de motores, bombas y transmisiones'
    }, {
      tema: 'Registro de la reparación',
      aprende: 'Documentar el trabajo como lo hace un técnico profesional'
    }],
    ficha: '✅ Casos incluidos: Reparación de motor eléctrico, cambio de rodamiento, corrección de fuga hidráulica y falla en sistema de transmisión por correas.'
  }, {
    id: 'T5',
    icon: '📊',
    title: 'TOMO 5 — Gestión del Mantenimiento',
    subtitle: 'El docente como Jefe de Mantenimiento: organizar 25 alumnos como si fuera una cuadrilla real.',
    table: [{
      tema: 'Planes de mantenimiento',
      aprende: 'Cómo se diseña, estructura y ejecuta un plan real'
    }, {
      tema: 'Organización del trabajo',
      aprende: 'Roles, turnos y responsabilidades en el taller escolar'
    }, {
      tema: 'Registro de tareas',
      aprende: 'Hojas de vida de equipos, órdenes de trabajo y bitácoras'
    }, {
      tema: 'Control de equipos',
      aprende: 'Indicadores simples para saber si el mantenimiento funciona'
    }, {
      tema: 'Gestión de repuestos',
      aprende: 'Inventario básico y criterios de reposición'
    }, {
      tema: 'Aplicación en escuela técnica',
      aprende: 'Cómo llevar esta lógica al taller sin recursos industriales'
    }],
    ficha: '✅ Plantillas incluidas: Orden de trabajo, hoja de vida del equipo, planilla de control semanal y registro de intervenciones listas para usar.'
  }, {
    id: 'T6',
    icon: '⚠️',
    title: 'TOMO 6 — Seguridad en Mantenimiento Industrial',
    subtitle: 'Porque el primer trabajo del técnico es volver a casa entero.',
    table: [{
      tema: 'Riesgos en el taller',
      aprende: 'Eléctricos, mecánicos, térmicos y químicos en contexto real'
    }, {
      tema: 'Normas básicas de seguridad',
      aprende: 'Las que aplican en el taller escolar y en cualquier planta'
    }, {
      tema: 'EPP específicos',
      aprende: 'Cuál usar, cuándo y por qué cada elemento importa'
    }, {
      tema: 'Bloqueo y etiquetado (LOTO)',
      aprende: 'El procedimiento que salva vidas, adaptado al nivel técnico'
    }, {
      tema: 'Procedimientos seguros',
      aprende: 'Cómo intervenir una máquina sin crear un accidente nuevo'
    }, {
      tema: 'Casos reales de accidentes',
      aprende: 'Análisis de situaciones reales para que el alumno entienda por qué las normas existen'
    }],
    ficha: '✅ Actividades incluidas: Identificación de riesgos en imágenes de taller, diseño de procedimientos seguros y análisis de casos de accidentes reales de la industria argentina.'
  }];
  const includes = [{
    recurso: '📖 Explicaciones técnicas',
    desc: 'Listas para enseñar sin adaptar ni reescribir'
  }, {
    recurso: '🔧 Ejemplos reales',
    desc: 'Del contexto industrial argentino, no de manuales europeos desactualizados'
  }, {
    recurso: '📋 Actividades de taller',
    desc: 'Listas para usar en clase sin preparación extra'
  }, {
    recurso: '❓ Preguntas de cierre',
    desc: 'Para el final de cada clase, ya formuladas'
  }, {
    recurso: '📝 Evaluaciones completas',
    desc: 'Con consignas claras y criterios de corrección incluidos'
  }, {
    recurso: '📊 Rúbricas de evaluación',
    desc: 'Para calificar trabajos de taller sin discusiones ni subjetividad'
  }, {
    recurso: '📅 Secuencias didácticas',
    desc: 'Listas por unidad, adaptables por año de cursada'
  }];
  return <section className="py-8 md:py-12 px-3 bg-brand-dark" data-id="element-185">
      <div className="max-w-4xl mx-auto" data-id="element-186">
        <div className="text-center mb-6" data-id="element-187">
          <h2 className="text-2xl md:text-4xl font-black text-white mb-2 uppercase text-shadow-lg" data-id="element-188">
            🏆 KIT PROFE™ — MANTENIMIENTO INDUSTRIAL LISTO
          </h2>
          <p className="text-lg md:text-xl font-black text-brand-accent neon-glow mb-2 uppercase" data-id="element-189">
            6 Tomos + 4 Bonos — Todo resuelto.
          </p>
          <p className="text-sm md:text-base text-gray-300 font-bold bg-white/5 inline-block px-4 py-1 rounded-full border border-white/10" data-id="element-190">
            +400 páginas listas para el taller y el aula.
          </p>
        </div>

        <div className="text-center mb-6" data-id="element-191">
          <h3 className="text-xl font-black text-black inline-flex items-center bg-brand-accent px-6 py-2 rounded-lg shadow-[0_4px_0_#CA8A04] uppercase" data-id="element-192">
            🔧 6 TOMOS COMPLETOS
          </h3>
        </div>

        <div className="space-y-3 mb-8" data-id="element-193">
          {tomos.map((tomo, i) => <div key={i} className="bg-brand-card border-2 border-white/10 rounded-xl overflow-hidden hover:border-brand-accent transition-colors shadow-lg" data-id="element-194">
              <button onClick={() => setOpenTomo(openTomo === i ? null : i)} className="w-full p-4 md:p-5 text-left flex items-start justify-between focus:outline-none bg-brand-card group" data-id="element-195">
                <div className="flex items-start flex-1" data-id="element-196">
                  <span className="text-2xl md:text-3xl mr-3 shrink-0 mt-1" data-id="element-197">
                    {tomo.icon}
                  </span>
                  <div data-id="element-198">
                    <span className={`block text-base md:text-xl font-black leading-tight mb-1 uppercase ${openTomo === i ? 'text-brand-accent' : 'text-white group-hover:text-brand-accent'}`} data-id="element-199">
                      {tomo.title}
                    </span>
                    <span className="block text-xs md:text-sm text-gray-400 font-medium" data-id="element-200">
                      {tomo.subtitle}
                    </span>
                  </div>
                </div>
                {openTomo === i ? <ChevronUp className="w-6 h-6 text-brand-accent shrink-0 ml-3 mt-1" data-id="element-201" /> : <ChevronDown className="w-6 h-6 text-gray-500 shrink-0 ml-3 mt-1 group-hover:text-brand-accent" data-id="element-202" />}
              </button>

              <div className={`px-4 md:px-5 overflow-hidden transition-all duration-300 ease-in-out bg-black ${openTomo === i ? 'max-h-[2000px] py-4 opacity-100 border-t-2 border-brand-accent/30' : 'max-h-0 opacity-0'}`} data-id="element-203">
                <div className="overflow-x-auto mb-4 rounded-lg border border-white/10" data-id="element-204">
                  <table className="w-full text-left border-collapse" data-id="element-205">
                    <thead data-id="element-206">
                      <tr className="bg-white/5 border-b-2 border-brand-accent/50" data-id="element-207">
                        <th className="py-3 px-3 text-brand-accent font-black text-xs md:text-sm w-1/3 uppercase" data-id="element-208">
                          Tema
                        </th>
                        <th className="py-3 px-3 text-brand-accent font-black text-xs md:text-sm uppercase" data-id="element-209">
                          Qué aprende el alumno
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-white/5" data-id="element-210">
                      {tomo.table.map((row, idx) => <tr key={idx} className="hover:bg-white/5 transition-colors" data-id="element-211">
                          <td className="py-3 px-3 text-white font-bold text-xs md:text-sm" data-id="element-212">
                            {row.tema}
                          </td>
                          <td className="py-3 px-3 text-gray-300 text-xs md:text-sm font-medium" data-id="element-213">
                            {row.aprende}
                          </td>
                        </tr>)}
                    </tbody>
                  </table>
                </div>

                <div className="bg-brand-accent/10 border-l-4 border-brand-accent p-3 md:p-4 rounded-r-lg" data-id="element-214">
                  <p className="text-sm md:text-base text-white font-bold leading-relaxed" data-id="element-215">
                    {tomo.ficha}
                  </p>
                </div>
              </div>
            </div>)}
        </div>

        <div className="bg-brand-card rounded-xl border-2 border-brand-accent overflow-hidden shadow-[0_0_30px_rgba(234,179,8,0.15)]" data-id="element-216">
          <div className="bg-brand-accent py-3 px-4 text-center border-b-4 border-brand-accentDark" data-id="element-217">
            <h4 className="text-lg md:text-xl font-black text-black uppercase tracking-wide" data-id="element-218">
              CADA TOMO INCLUYE
            </h4>
          </div>
          <div className="p-4 md:p-6" data-id="element-219">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-y-4 gap-x-8" data-id="element-220">
              {includes.map((item, i) => <div key={i} className="flex items-start" data-id="element-221">
                  <CheckCircle2 className="w-5 h-5 text-brand-accent mr-3 shrink-0 mt-0.5" data-id="element-222" />
                  <div data-id="element-223">
                    <span className="text-sm md:text-base font-black text-white block mb-0.5" data-id="element-224">
                      {item.recurso}
                    </span>
                    <span className="text-xs md:text-sm text-gray-400 font-medium" data-id="element-225">
                      {item.desc}
                    </span>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}